// extracted by css-extract-rspack-plugin
export default {"root":"EFbxlGopo3W3YXNt"};